module.exports = __webpack_public_path__ + "static/media/SherbourneLimited.294d2a64.svg";